import '@ant-design/compatible/assets/index.css';
import React, { useEffect, useMemo, useState } from 'react';
import { Checkbox, InputNumber, Row, Spin } from 'antd';
import DF from 'DisplayFramework';
import Form, { FormInstance } from 'antd/lib/form';
import UtinaCard from 'components/UtinaCard';
import FormInput from 'components/FormInput';
import Value from 'components/Value';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { toCurrency } from 'utils/utils';
// import ParListSelect from 'components/ParListSelect';
import { useQuery } from 'react-query';
import { getFinAssetsByID } from 'services/finassets';
import { isNil } from 'lodash';
import ParListSelect from 'components/ParListSelect';

export type TabFinModificationReviewProps = {
  objectid?: number;
  subentityid?: number;
  form?: FormInstance;
  setSuccessful?: any;
  entityReference?: string;
  onSelect?: any;
  handleModid?: (item: any) => void;
  modId?: any;
  isTab?: any;
  dataModid?: number;
  ctrid: number;
};
const TabSplitFinAsset = ({
  objectid,
  form,
  ctrid,
}: TabFinModificationReviewProps) => {
  const { data, isLoading } = useQuery(
    ['getFinAssetsByID', objectid],
    () => getFinAssetsByID({ assetid: objectid! }).then((res) => res.data),
    {
      enabled: !isNil(objectid),
    }
  );

  const [flagsplitComponent, setFlagsplitComponent] = useState(false);

  const [hasAccessComp, sethasAccessComp] = useState(false);

  useEffect(() => {
    if (data) {

      let hasComp =
        data?.assetmulticomponents &&
        data?.finAssetComponents.find(
          (asset) => asset.compcategory === 'TRUACC'
        ) !== undefined;

      sethasAccessComp(hasComp);

      form?.setFieldsValue({
        assetreference: data.assetreference,
        assetlabel: data.assetlabel,
        assetnetamount: data.assetnetamount,
        assetqty: data.assetqty,
        event: 'tabSplitFinAssetOrComponent',
        ctrid: ctrid,
      });
    }
  }, [data]);

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'comptype',
        width: 150,
        render: (_, record, index) => {
          return <ParListSelect parcode="COMPTYPE" value={_} disabled />;
        },
        fixed: 'left',
      },
      {
        dataIndex: 'compcategory',
        width: 150,
        render: (_, record, index) => {
          return <ParListSelect parcode="COMPCAT" value={_} disabled />;
        },
        fixed: 'left',
      },
      {
        dataIndex: 'compdescription',
        width: 300,
      },

      {
        dataIndex: 'compnetamount',
        render: (_value, _record, index) =>
          toCurrency(
            _value,
            _record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
        width: 150,
      },
      {
        dataIndex: 'compgrossamount',
        key: 'compgrossamount',
        render: (_value, _record, index) =>
          toCurrency(
            _value,
            _record.currcode ?? localStorage.getItem('currcode') ?? ''
          ),
        fixed: 'right',
        width: 120,
      },
    ],
    [data?.finAssetComponents]
  );

  return (
    <DF.Provider pagcode="tabSplitFinAsset">
      <Spin spinning={isLoading}>
        <Form
          form={form}
          initialValues={{ assetqty: 0, qty: 0, flagsplitComponent: false }}
        >
          <UtinaCard comcode="splitFinAsset" level={5} lg={23}>
            <Row gutter={30}>
              <FormInput col md={7} name="assetreference">
                <Value />
              </FormInput>
              <FormInput col md={7} name="assetlabel">
                <Value />
              </FormInput>
              <FormInput col md={7} name="assetnetamount">
                <Value formatter={toCurrency} />
              </FormInput>
            </Row>
            <Row gutter={30}>
              {hasAccessComp && (
                <FormInput
                  col
                  md={7}
                  name="flagsplitComponent"
                  wrapperCol={{ span: 7 }}
                >
                  <Checkbox
                    onChange={(e) => {
                      setFlagsplitComponent(e.target.checked);
                      form?.setFieldsValue({
                        flagsplitComponent: e.target.checked,
                        qty: 0,
                      });
                    }}
                  />
                </FormInput>
              )}

              <FormInput col md={7} name="assetqty">
                <Value />
              </FormInput>

              {!flagsplitComponent && data && data?.assetqty > 1 && (
                <FormInput col md={7} name="qty" wrapperCol={{ span: 8 }}>
                  <InputNumber max={data?.assetqty} min={0} />
                </FormInput>
              )}
            </Row>
            <Row>
              <DataGrid
                title="components"
                columns={columns}
                dataSource={data?.finAssetComponents}
                rowKey={({ compid }) => compid}
                hideFilters
                isLoading={isLoading}
              />
            </Row>
          </UtinaCard>
        </Form>
      </Spin>
    </DF.Provider>
  );
};
export default TabSplitFinAsset;
